interface NewPostsIconProps {
  size?: number;
  className?: string;
}

const NewPostsIcon: React.FC<NewPostsIconProps> = ({ size = 16, className }) => {
  return (
    <svg
      className={className}
      width={size}
      height={size}
      viewBox="0 0 16 16"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      style={{ display: 'inline-block', verticalAlign: 'middle' }}
      aria-hidden="true"
    >
      <g className="newPostsFlySheet">
        <rect
          x="2.25"
          y="2.25"
          width="11.5"
          height="11.5"
          rx="2.25"
          stroke="currentColor"
          strokeWidth="1.2"
          opacity="0.75"
        />
        <path
          d="M5 6.6H9M5 8.8H10.8"
          stroke="currentColor"
          strokeWidth="1.15"
          strokeLinecap="round"
          opacity="0.75"
        />
      </g>
      <rect
        x="2.25"
        y="2.25"
        width="11.5"
        height="11.5"
        rx="2.25"
        stroke="currentColor"
        strokeWidth="1.35"
      />
      <path
        d="M5 6H8.6M5 8.4H11M5 10.8H9.8"
        stroke="currentColor"
        strokeWidth="1.35"
        strokeLinecap="round"
      />
      <circle cx="11.6" cy="4.4" r="1.2" fill="currentColor" />
    </svg>
  );
};

export default NewPostsIcon;
